import React, { useContext, useRef, useState } from 'react';
import { Select } from 'antd';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getFeeDueList } from '../../NecttosComp/APICaller/ApiServices';
import { useAllClasses } from '../../NecttosComp/APICaller/queryHooks';
import moment from 'moment';
import LoadingAnimation from '../../components/LoadingAnimation';
import Button from '../../NecttosComp/Button/Button';
import { Main,Body,Header } from '../../NecttosComp/Layout/Layout';
import { Table,Thead,Tbody,Tr,Td ,Th} from '../../NecttosComp/Table/Table';
import Input2 from '../../NecttosComp/Input/Input2';
import Instruction from '../../Documentation/Instruction';

export const DuesReport = ({ onClose }) => {
	const allClasses = useAllClasses({ needAll: true, classOnly: true });
	const { collegeId, collegeList } = useContext(FirebaseContext);
	const componentRef = useRef();
	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);
	const [state, setState] = useState({});
	const [loading, setLoading] = useState(false);

	let skip = 0;
	let limit = 70;
	let search = '';
	const noNeedTotals = true;

	const { data, refetch, isLoading } = useQuery(
		['feeDueList', state.classId],
		getFeeDueList(collegeId, skip, limit, search, noNeedTotals, state?.classId),
		{ keepPreviousData: true }
	);

	data?.data?.forEach((element) => {
		element.groups.forEach((item) => {
			element[item.feeType] = item.totalCurrentDue === 0 ? '' : item.totalCurrentDue;
		});
	});

	let issuedData = data?.data?.sort((a, b) => a.userName?.localeCompare(b.userName)) || [];

	return (
		<Main title='Dues Report' width='90vw' height='90vh'>
			<Header width='100%'>
				<div className='w-[50%] flex '>
					<Input2
					   didntShowKey
						type='drop'
						className='w-[320px]'
						fieldName='Select Class'
						returnKey='classId'
						optionDisplay='label'
						optionKey='value'
						options={(allClasses?.data || []).map((x, i) => ({
							label: x.className,
							value: x.classId,
						}))}
						state={state}
						setState={setState}
					/>
				</div>
				<div className='w-[50%] flex justify-end'>
					<Button type='refresh' onClick={refetch}>Load</Button>
					<Button type='print' tableRef={componentRef.current}>
							Print
						</Button>
						<Button type='excel' tableRef={componentRef.current}>
							Excel
						</Button>
						<Instruction keyId={'duesReport'}></Instruction>
					<Button type='close' onClick={onClose}>Close</Button>
				</div>
			</Header>

			<Body>
				{isLoading ? (
					<LoadingAnimation customHeight={700} customWidth={700} />
				) : (
					<div ref={componentRef} className='printable'>
						<img
							className='absolute w-4/5 mt-64 left-1/2 -translate-x-1/2 opacity-10 -z-10'
							src={selectedCollege?.logo}
							alt='College Watermark'
						/>
						<div className='w-full flex flex-col rounded-[25px] p-[1%]'>
							<div className='w-full flex items-start gap-4'>
								<img className='w-[50px] h-[50px] object-contain' src={selectedCollege?.logo} alt='College Logo' />
								<div className='flex flex-col text-left'>
									<span className='text-[20px] font-black dark:text-white'>{selectedCollege?.collegeShortName}</span>
									<p className='text-[25px] font-black dark:text-white'>{selectedCollege?.accreditedGrade}</p>
									<p className='text-[14px] font-black dark:text-white'>
										{state?.className} Fee Due Report as on {moment().format('DD MMM YYYY hh:mm A')}
									</p>
								</div>
							</div>
							<div className='mt-4'>
								<Table width='100%' innerWidth={['5%', '10%','20%', '20%', '15%', '10%', '10%', '10%']}>
  <Thead>
    <Tr>
      <Th position={0}>Sn</Th>
      <Th position={1}>Admn No</Th>
      <Th position={2}>Name</Th>
      <Th position={3}>Mobile</Th>
      <Th position={4}>Tuition Fee</Th>
      <Th position={5}>Exam Fee</Th>
      <Th position={6}>Other Fee</Th>
	   <Th position={7}>Last Pay Date</Th>
    </Tr>
  </Thead>
  <Tbody>
    {issuedData.map((item, i) => (
      <Tr key={i} className={item.status === 'renew' ? 'bg-green-100' : 'bg-white'}>
        <Td index={i} position={0} className='text-center'>{i + 1}</Td>
        <Td index={i} position={1}>{item.admnNo}</Td>
        <Td index={i} position={2}>{item.userName}</Td>
        <Td index={i} position={3}>{item.sMobile}</Td>
        <Td index={i} position={4} className='text-center'>{item.TuitionFee}</Td>
        <Td index={i} position={5} className='text-center'>{item.ExamFee}</Td>
        <Td index={i} position={6} className='text-center'>{item.Others}</Td>
		<Td index={i} position={7} className='text-center'></Td>
      </Tr>
    ))}
  </Tbody>
</Table>

								<h5 className='mt-4 text-right text-[10px] dark:text-white'>Seal & Signature {moment().format('DD MMM YYYY hh:mm A')}</h5>
							</div>
						</div>
					</div>
				)}
			</Body>
		</Main>
	);
};
